export const OUR_OFFERS = [{
  type: '1-to-1',
  duration: '60 min.',
  studentsNumber: '1',
  price: 35
}, {
  type: 'Group',
  duration: '60 min.',
  studentsNumber: 'up to 4',
  price: 60
}, {
  type: 'Group',
  duration: '90 min.',
  studentsNumber: 'up to 6',
  price: 70
}];